import { render, staticRenderFns } from "./FiftyMinDataTable.vue?vue&type=template&id=284cbb37&scoped=true"
import script from "./FiftyMinDataTable.vue?vue&type=script&lang=js"
export * from "./FiftyMinDataTable.vue?vue&type=script&lang=js"
import style0 from "./FiftyMinDataTable.vue?vue&type=style&index=0&id=284cbb37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284cbb37",
  null
  
)

export default component.exports